import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "info",
    templateUrl: "./info.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class InfoComponent {}
